import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import Text from './typography/Text';

export default function ItemDetailsInfo({
  icon,
  label = '',
  className = '',
  iconClassName = '',
}) {
  const { whiteLabelSettings: { secondaryColour } = {} } =
    useWhiteLabelSettings();

  return (
    <div className={`${className} flex items-center mt-2 min-w-0`}>
      <div
        style={{ color: secondaryColour, fill: secondaryColour }}
        className={`${iconClassName} text-xl mr-2 flex-shrink-0`}
      >
        {icon}
      </div>
      <Text className="mt-1 flex-1 min-w-0 break-words text-sm">
        {label || '-'}
      </Text>
    </div>
  );
}
